import graphql from 'babel-plugin-relay/macro';
import { useMutation } from 'react-relay';

import { CreateProctorMutation } from './__generated__/CreateProctorMutation.graphql';

const createProctorMutation = graphql`
  mutation CreateProctorMutation(
    $key: String!
    $firstName: String
    $lastName: String
    $state: String
    $regionIds: [ID]
  ) {
    createProctor(
      input: {
        key: $key
        firstName: $firstName
        lastName: $lastName
        state: $state
        regionIds: $regionIds
      }
    ) {
      id
      key
      firstName
      lastName
      state
      regions {
        id
        name
      }
    }
  }
`;

const useCreateProctorMutation = () =>
  useMutation<CreateProctorMutation>(createProctorMutation);

export { useCreateProctorMutation };
